<template>
  <menu-component
    menu-type="gallery"
    :title="$t('gallery.gallery')"
    :menu-items="{
      1: {
        text: $t('gallery.pictures'),
        route: $getWebView('GalleryView'),
        current: isFirstTab ? $getWebView('GalleryRepeatableView') : '',
        notification: picturesNotification
      },
      2: {
        text: $t('gallery.convertor'),
        route: $getWebView('GalleryConverter'),
      },
      3: {
        text: $t('gallery.packs'),
        route: $getWebView('GalleryPacks'),
        notification: galleryNotifications?.packs || 0
      },
    }"
    :sub-menu-active="isSubMenuActive"
    :sub-menu="
      isSubMenuActive
        ? {
            1: {
              text: $t('gallery.collections'),
              active: false,
              route: $getWebView('GalleryView'),
              notification: galleryNotifications?.collections || 0
            },
            2: {
              text: $t('gallery.repeatable'),
              active: false,
              route: $getWebView('GalleryRepeatableView'),
              notification: galleryNotifications?.repeatable || 0
            },
            3: {
              text: $t('gallery.special'),
              active: false,
              route: $getWebView('GallerySpecialView'),
              notification: galleryNotifications?.special || 0
            },
          }
        : {}
    "
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { useResponseTaskStore } from '@/store/pinia/responseTaskStore'

interface GalleryNotificationsObj {
  collections?: number
  repeatable?: number
  special?: number
  packs?: number
}

export default defineComponent({
  name: 'GalleryMenu',

  props: {
    isSubMenuActive: {
      type: Boolean,
      default: false
    },

    isFirstTab: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState(useResponseTaskStore, ['getNotifications']),

    galleryNotifications(): GalleryNotificationsObj | null {
      return this.getNotifications?.gallery_notifications || null
    },

    picturesNotification(): number {
      if (!this.galleryNotifications) return 0
      return (this.galleryNotifications?.collections || 0) +
        (this.galleryNotifications?.repeatable || 0) +
        (this.galleryNotifications?.special || 0)
    }
  }
})
</script>
